<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="tw-flex tw-items-center">
        <div class="tw-flex-grow">
          <h5>
            Contact List
          </h5>
        </div>

        <div>
          <SelectWidget
              v-model="isActive"
              class="input-sm"
              :options="[{value: 1, label: 'Show active'}, {value: 0, label: 'Show inactive'}]"
          />
        </div>
      </div>
    </div>

    <LoadingSpinner v-if="loading" class="tw-m-16"/>

    <div v-else-if="people.data.length">
      <ContactItem v-for="person in people.data" :key="person.id" :person="person" :mailing-lists="mailingLists"/>

      <Pager v-if="people.meta.last_page !== 1" :pagination="people.meta" @navigate="page = $event"/>
    </div>

    <div v-else class="tw-flex tw-justify-center tw-py-16">
      <i>
        There are no contacts to display,
      </i>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import ContactItem from "./ContactItem.vue";
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import SimplePager from "../../../../../../../components/Lists/SimplePager.vue";
import Pager from "../../../../../../../components/Lists/Pager.vue";

export default {
  components: {Pager, SimplePager, ContactItem, LoadingSpinner, SelectWidget},

  props: ['company'],

  data() {
    return {
      people: null,
      mailingLists: null,

      isActive: 1,

      loading: true,
      page: 1,
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    isActive() {
      this.load()
    },

    page() {
      this.load()
    }
  },

  methods: {
    load() {
      this.loading = true

      Promise.all([
        http.get('/api/v2/people', {
          'filter[company_id]': this.company.data.id,
          'filter[is_active]': this.isActive,
          sort: '-is_advertising_contact,-is_subscription_contact,name',
          page: this.page,
          page_size: 10
        }),
        http.get('/api/v2/external/mailing-lists')
      ]).then(responses => {
        this.people = responses[0].data

        this.mailingLists = responses[1].data.data

        this.loading = false
      })
    }
  },
}
</script>
